import React from 'react';
import ReactDOM from 'react-dom';
import fetch from 'unfetch';
import { csvParse } from 'd3-dsv';
import polylabel from 'polylabel';
import { feature as topo2geo, merge } from 'topojson-client';

import { isNumeric } from '~/core/scripts/utils';
import Section from './Section';

const columns = [
  { key: 'oeko_auto', label: 'Elektro-Autos', unit: '%', decimals: 1, visible: true },
  { key: 'oeko_anteil', label: 'Ökostrom-Wechsler', unit: '%', decimals: 0, visible: true },
  { key: 'muell_pk', label: 'Müll pro Kopf', unit: 'kg', decimals: 0, visible: true },
  { key: 'schutzgebiete', label: 'Naturschutzgebiete', unit: '%', decimals: 0, visible: true },
  { key: 'bike', label: 'Fahrräder', unit: '%', decimals: 0, visible: true },
  { key: 'Gruene', label: 'Grüne', unit: '%', decimals: 0, visible: false }
];

export async function loadData() {
  const topoResp = await fetch('data/kreise.topo.json');
  const topojsonRaw = await topoResp.json();

  const csvResp = await fetch('data/data.csv');
  const csvDataString = await csvResp.text();
  const dataRaw = csvParse(csvDataString, (d) => {
    columns.forEach((col) => {
      d[col.key] = +d[col.key];
      d[`${col.key}_abs`] = +d[`${col.key}_abs`];
    });

    d.Gruene = +d.Gruene;
    d.Gruene_abs = +d.Gruene_abs;

    return d;
  });

  const germanyData = dataRaw.find(d => d.AGS === '999');

  const data = dataRaw.map((d) => {
/*    const greenestIndex = columns.reduce((res, col) => {
      const isAbove = col.key !== 'muell_pk' && d[col.key] > germanyData[col.key];
      const isBelow = col.key === 'muell_pk' && d[col.key] < germanyData[col.key];

      if (isAbove || isBelow) {
        res++;
      }

      return res;
    }, 0);  */

    return {
      ...d,
      rank: +d.rank,
      greenestIndex: +d.group
    };
  });

  const dataInfo = columns.map(col => {
    const values = data.map(d => d[col.key]).filter(d => isNumeric(d) && !['888', '999'].includes(d.AGS));
    const germanyData = data.find(d => d.AGS === '999');
    const greenData = data.find(d => d.AGS === '888');

    const min = Math.min(...values);
    const max = Math.max(...values);
    const avg = germanyData[col.key];
    const avgGreen = greenData[col.key];

    return {
      min,
      max,
      avg,
      avgGreen,
      ...col
    };
  });

  const key = Object.keys(topojsonRaw.objects)[0];
  const topojson = mergeTopoWithData(topojsonRaw, data, 'Wahlgebiet_ID');
  const geojson = topo2geo(topojson, topojson.objects[key]);
  const topoJsonObject = topojson.objects[key];

  const filteredGeojson = merge(
    topojson,
    topoJsonObject.geometries.filter(geom => geom.properties.Gruene >= germanyData.Gruene)
  );

  const stateGeojson = mergeTopojsonByKey(topojson, 'Bundesland');

  return {
    geojson,
    filteredGeojson,
    stateGeojson,
    data,
    dataInfo
  };
}

function mergeTopoWithData(topojson, data, mergeKey) {
  const topoKey = Object.keys(topojson.objects)[0];
  const geometriesWithData = topojson.objects[topoKey].geometries.map(geom => {
    const matchingData = data.find(d => d[mergeKey] === geom.properties[mergeKey]);

    geom.properties = {
      ...geom.properties,
      ...matchingData
    };

    return geom;
  });

  topojson.objects[topoKey].geometries = geometriesWithData;

  return topojson;
}


export function renderSection(selector, props) {
  ReactDOM.render(<Section {...props} />, document.querySelector(selector));
}

export function getCentroid(geojson, AGS) {
  const matchingFeat = geojson.features.find(f => f.properties.AGS === AGS);
  const coordinates = matchingFeat.geometry.type === 'MultiPolygon' ? matchingFeat.geometry.coordinates[0] : matchingFeat.geometry.coordinates;

  return polylabel(coordinates, 1.0).reverse();
}

function mergeTopojsonByKey(topoJsonData, propertyKey) {
  const key = Object.keys(topoJsonData.objects)[0];
  const topoJsonObject = topoJsonData.objects[key];
  const groups = topoJsonObject.geometries
    .reduce((res, item) => {
      const currentValue = item.properties[propertyKey];

      if (!res.includes(currentValue)) {
        res.push(currentValue);
      }

      return res;
    }, [])
    .map(value =>
      merge(
        topoJsonData,
        topoJsonObject.geometries.filter(d => d.properties[propertyKey] === value)
      )
    );

  return groups;
}
